export default __webpack_public_path__ + "static/0255-b49734b1f72b87b871712cd61b78011a.png";